import {
  USUARIOALTA_ORDEN,
  USUARIOALTA_ORDEN_SUCCESS, USUARIOALTA_ORDEN_FAIL
} from "../ActionTypes";

const usuarioAltaOrden = (state, { payload, type }) => {
  switch (type) {
    case USUARIOALTA_ORDEN:
      return {
        ...state,
        usuarioAltaOrden: {
          ...state.usuarioAltaOrden,
          loading: true,
          error: false,
          estado: null,
        },
      };
    case USUARIOALTA_ORDEN_SUCCESS:
      return {
        ...state,
        usuarioAltaOrden: {
          ...state.usuarioAltaOrden,
          loading: false,
          error: false,
          estado: payload,
        },
      };
    case USUARIOALTA_ORDEN_FAIL:
      return {
        ...state,
        usuarioAltaOrden: {
          ...state.usuarioAltaOrden,
          loading: false,
          error: payload,
          estado: null,
        },
      };

    default:
      return state;
  }
};

export default usuarioAltaOrden;
